<template lang='pug'>
  .sidebar
    SidebarHeader
    nav.sidebar-nav
      ul.nav
        template(v-for='(item, index) in navList')
          template(v-if='item.auth')
            template(v-if='item.title')
              SidebarNavTitle(:name='item.name', :classes='item.class', :wrapper='item.wrapper')
            template(v-else-if='item.divider')
              SidebarNavDivider(:classes='item.class')
            template(v-else-if='item.label')
              SidebarNavLabel(:name='item.name', :url='item.url', :icon='item.icon', :label='item.label', :classes='item.class')
            template(v-else)
              template(v-if='item.children')
                //- First level dropdown
                SidebarNavDropdown(:name='item.name', :url='item.url', :icon='item.icon')
                  template(v-for='(childL1, index) in item.children')
                    template(v-if='childL1.children')
                      //- Second level dropdown
                      SidebarNavDropdown(:name='childL1.name', :url='childL1.url', :icon='childL1.icon')
                        li.nav-item(v-for='(childL2, index) in childL1.children')
                          SidebarNavLink(:name='childL2.name', :url='childL2.url', :icon='childL2.icon', :badge='childL2.badge', :variant='item.variant')
                    template(v-else)
                      SidebarNavItem(:classes='item.class')
                        SidebarNavLink(:name='childL1.name', :url='childL1.url', :icon='childL1.icon', :badge='childL1.badge', :variant='item.variant')
              template(v-else)
                SidebarNavItem(:classes='item.class')
                  SidebarNavLink(:name='item.name', :url='item.url', :icon='item.icon', :badge='item.badge', :variant='item.variant')
      slot
    SidebarFooter
    SidebarMinimizer
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
import Policeman from '@/utils/Policeman/policeman'

export default {
  name: 'sidebar',
  data () {
    return {
      navList: []
    }
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },
  mounted () {
    let newItems = this.$props.navItems.map((item) => {
      item.auth = Policeman.authorize(item.roles)
      delete item.roles
      return item
    })
    this.$set(this.$data, 'navList', newItems)
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue